export const selectIsLoading = (state) => state.dialog.showLoader > 0;

export const selectCommonDialog = (state) => state.dialog.commonDialog;

export const selectIsOpen = (state, name) => state.dialog.namedDialogs[name];

export const selectError = (state, name) => state.dialog.errors[name];
